var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentSatisfied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8335 18.333C27.2142 18.333 28.3335 17.2137 28.3335 15.833C28.3335 14.4523 27.2142 13.333 25.8335 13.333C24.4528 13.333 23.3335 14.4523 23.3335 15.833C23.3335 17.2137 24.4528 18.333 25.8335 18.333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 18.333C15.5475 18.333 16.6668 17.2137 16.6668 15.833C16.6668 14.4523 15.5475 13.333 14.1668 13.333C12.7861 13.333 11.6668 14.4523 11.6668 15.833C11.6668 17.2137 12.7861 18.333 14.1668 18.333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 26.6663C17.5335 26.6663 15.4168 25.3163 14.2502 23.333H11.4668C12.8002 26.7497 16.1168 29.1663 20.0002 29.1663C23.8835 29.1663 27.2002 26.7497 28.5335 23.333H25.7502C24.6002 25.3163 22.4668 26.6663 20.0002 26.6663ZM19.9835 3.33301C10.7835 3.33301 3.3335 10.7997 3.3335 19.9997C3.3335 29.1997 10.7835 36.6663 19.9835 36.6663C29.2002 36.6663 36.6668 29.1997 36.6668 19.9997C36.6668 10.7997 29.2002 3.33301 19.9835 3.33301ZM20.0002 33.333C12.6335 33.333 6.66683 27.3663 6.66683 19.9997C6.66683 12.633 12.6335 6.66634 20.0002 6.66634C27.3668 6.66634 33.3335 12.633 33.3335 19.9997C33.3335 27.3663 27.3668 33.333 20.0002 33.333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentSatisfied);
export default __webpack_public_path__ + "static/media/sentiment_satisfied.25645d4452be2220a38cb56b09031377.svg";
export { ForwardRef as ReactComponent };